/**
 * Firebase Configuration - ASCIN Supply Chain Intelligence
 * Unified authentication across all Sentient Suite apps
 * Using same config as ForceAI and other apps for SSO
 */

import { initializeApp, getApps } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Firebase config - executive-force-ai-453011 (unified across all Sentient Suite apps)
// These are PUBLIC frontend credentials - safe to include in client-side code
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDzSVcepxdliuW-nM026lRmopvg324Q-XY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "executive-force-ai-453011.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "executive-force-ai-453011",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "executive-force-ai-453011.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "327026071945",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:327026071945:web:17e73a735d4ac4cc25a958",
};

// Initialize Firebase (prevent re-initialization on hot reload)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Log initialization status
console.log('🔥 Firebase initialized for ASCIN:', firebaseConfig.projectId);

export default app;
